import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { ResponseProvider } from "./context/responseContext";
import { OfferProvider } from "./context/offerContext";
import { EmailProvider } from "./context/emailContext";

ReactDOM.render(
  <Router basename="/">
    <React.StrictMode>
      <ResponseProvider>
        <OfferProvider>
          <EmailProvider>
            <App />
          </EmailProvider>
        </OfferProvider>
      </ResponseProvider>
    </React.StrictMode>
  </Router>,
  document.getElementById("root")
);

// Register the service worker and background sync
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    if ('SyncManager' in window) {
      registration.sync.register('mediuk-sync').then(() => {
        console.log('Background Sync registered successfully.');
      }).catch((err) => {
        console.error('Background Sync registration failed:', err);
      });
    } else {
      console.warn('Background Sync is not supported in this browser.');
    }
  },
  onUpdate: (registration) => {
    console.log('Service Worker updated.');
  },
});


reportWebVitals();